import { Col } from "react-bootstrap";
import { ContentModel } from "./contentModel";

export const Content = (props: ContentModel) => {
  const { children } = props;
  return (
    <Col {...props}>
      <div className={`content`}>{children}</div>
    </Col>
  );
};
